import GLightbox from '../../node_modules/glightbox/dist/js/glightbox.js';
require('../../node_modules/glightbox/dist/css/glightbox.css');

document.addEventListener('DOMContentLoaded', () => {

    if (document.body.classList.contains('page-frontline')) {
        const video = GLightbox({
            selector: ".js-video"
        });
    }

}, false);
